<template>
  <div class="home">
    <main-navigation animation />
    <div style="min-height:400px">
      <router-view />
    </div>
    <footer-navigation animation />
  </div>
</template>

<script>
// @ is an alias to /src
import MainNavigation from '@/components/navigation/MainNavigation.vue'
import FooterNavigation from '@/components/navigation/FooterNavigation.vue'

export default {
  name: 'home',
  components: {
    MainNavigation,
    FooterNavigation
  }
}
</script>
